import React from "react";
import { string, bool } from "prop-types";
import { twMerge } from "tailwind-merge";

const Divider = ({ vertical = false, className }) => (
  <hr
    className={twMerge(
      "bg-primaryOrange border-0",
      vertical ? "h-auto w-[2px]" : "h-[2px] w-full",
      className
    )}
  />
);

Divider.propTypes = {
  className: string,
  vertical: bool,
};

export default Divider;
